<div class="page-container">
    <app-header
        title="{{ 'change-requests.people' | translate }}"
        [menuService]="employeeModuleMenuService"
    ></app-header>
    <app-table [table]="table" [title]="'employees.menu.requestTemplate' | translate" [showSearch]="false"></app-table>
</div>
